import { menuBuilderListCopy } from 'src/constants/menuBuilderCopy'
import { getRecipePlanAllowance } from 'src/constants/recipePlanAllowances'
import { calculateMenuHealthScore } from 'src/utils/menuBuilderMenuHealth'
import {
  formatSlotsRemainingShort,
  getMenuBuilderLimitDisplay,
} from 'src/utils/menuBuilderLimitDisplay'
import { formatNoPricesYetCount } from 'src/utils/recipeGpReview'

/**
 * “2 left” / “Limit reached” follow how many recipes the plan can store
 * (Free 50, Starter 200, Growth and Pro unlimited). The monitor cap stays
 * on the monitoring line. The old 5 / 50 / 100 figures are not a storage wall.
 */
export const recipeListStoreWall = ({
  storedCount = 0,
  currentPlan = 'Free',
} = {}) => {
  const stored = Math.max(0, Number(storedCount) || 0)
  const { storeMax } = getRecipePlanAllowance(currentPlan)
  if (storeMax == null) return null
  if (stored >= storeMax) return menuBuilderListCopy.limitReachedShort
  return formatSlotsRemainingShort(storeMax - stored)
}

export const buildMenuBuilderListHeaderLine = ({
  recipes = [],
  currentPlan = 'Free',
  usageLimits = {},
  storedCount,
}) => {
  const menuHealth = calculateMenuHealthScore(recipes)
  const limitDisplay = getMenuBuilderLimitDisplay({
    recipeCount: recipes.length,
    currentPlan,
    usageLimits,
  })
  const stored =
    storedCount == null ? recipes.length : Math.max(0, Number(storedCount) || 0)

  const healthLabel = menuBuilderListCopy.menuHealthLabel
  const recipeCountLabel =
    menuHealth.scoredCount === 1
      ? '1 recipe'
      : `${menuHealth.scoredCount} recipes`
  const healthPart = menuHealth.hasScore
    ? `${healthLabel} ${menuHealth.displayValue} · ${menuHealth.band.label} · ${recipeCountLabel}`
    : `${healthLabel} —`
  const noPricesPart = formatNoPricesYetCount(menuHealth.noPricesCount)

  let limitPart = null
  if (limitDisplay.showLimitUi) {
    limitPart = limitDisplay.slotsUsedText
  }
  const storeWall = recipeListStoreWall({ storedCount: stored, currentPlan })
  if (storeWall) {
    limitPart = limitPart ? `${limitPart} · ${storeWall}` : storeWall
  }

  return {
    menuHealth,
    limitDisplay,
    healthPart,
    noPricesPart,
    limitPart,
  }
}
